export enum DataSharingStatus {
    DECISION_REQUIRED = 0,
    ORGANISATION_OPT_OUT = 1,
    INSPECTION_OPT_OUT = 2,
    OPTED_IN = 3
}
